import React, { useEffect, useState } from "react";
import PageContainer from "../../components/PageContainer";
import Category from "./components/Category";
import Step from "./components/Step";
import Loading from "./components/Loading";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import {
  findLawyerService,
  getCategories,
  getSubCategories,
} from "./consulting.api";
import { message } from "antd";
import { ContractsAndJudicialDocumentsTypes, RootCategoriesTypes } from "../../constant/Types";
import { LeftOutlined } from "@ant-design/icons";
import ProvincesAndCities from "./components/ProvincesAndCities";

const Consulting = () => {
  let history = useHistory();
  const { state } = useLocation();
  const { rootType } = useParams();
  const [step, setStep] = useState(0);
  const [tags, setTags] = useState([]);
  const [isFinding, setIsFinding] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingPercent, setLoadingPercent] = useState(0);
  const [categories, setCategories] = useState([]);
  const [lastCat, setLastCat] = useState("");

  useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line
  }, []);

  function fetchCategories() {
    setIsLoading(true);
    getCategories(rootType)
      .then((resp) => {
        setIsLoading(false);
        setCategories(resp.data);
      })
      .catch((error) => {
        setIsLoading(false);
        setCategories([]);
        console.error(error);
      });
  }

  function handleChangeStep(step, tag, item) {
    setStep(step);
    setTags([...tags, tag]);

    if (item.leaf) {
      findLawyer(item.id);
    } else {
      getCategoriesChildren(item.id);
    }
  }

  function getCategoriesChildren(id) {
    setIsLoading(true);
    getSubCategories(id)
      .then((resp) => {
        setCategories(resp.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        message.error("دریافت اطلاعات با خطا مواجه شد!");
      });
  }

  function findLawyer(catId) {
    setLastCat(catId);
    setIsFinding(true);
    setLoadingPercent(50);
    setHasError(false);

    let loader = setTimeout(() => {
      setLoadingPercent(65);
    }, 3000);

    let loader2 = setTimeout(() => {
      setLoadingPercent(75);
    }, 4000);

    findLawyerService(catId)
      .then((resp) => {
        clearTimeout(loader);
        clearTimeout(loader2);
        setLoadingPercent(100);
        setTimeout(function () {
          history.push(`/consultation/${rootType}/${resp.data.sessionId}`);
        }, 1000);
      })
      .catch((error) => {
        setHasError(true);
        message.error("ارسال درخواست با مشکل مواجه شد");
      });
  }

  return (
    <PageContainer
      classNames={"consulting"}
      headerProps={{
        content: {...RootCategoriesTypes, ...ContractsAndJudicialDocumentsTypes}?.[rootType]?.value,
        link: {...RootCategoriesTypes, ...ContractsAndJudicialDocumentsTypes}?.[rootType]?.link,
        left: (
          <Link to={state && state.prevPath ? state.prevPath : (Object.keys(ContractsAndJudicialDocumentsTypes).includes(rootType) ? RootCategoriesTypes.contracts_and_judicial_documents.url : "/consulting")}>
            <LeftOutlined />
          </Link>
        ),
      }}
      loading={isLoading}
    >
      <div className="title-holder">
        <h2 className={"title"}> {{...RootCategoriesTypes, ...ContractsAndJudicialDocumentsTypes}[rootType].value} </h2>
      </div>
      <Step step={step} isFinding={isFinding} rootType={rootType} />
      {rootType === "advocacy_acceptation" && !isFinding && <ProvincesAndCities />}
      {isFinding ? (
        <Loading
          percent={loadingPercent}
          hasError={hasError}
          findLawyer={() => findLawyer(lastCat)}
        />
      ) : (
        <Category
          step={step}
          tags={tags}
          categories={categories}
          changeStep={handleChangeStep}
          isLoading={isLoading}
          type={rootType}
        />
      )}
    </PageContainer>
  );
};

export default Consulting;
